import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/artshow";

export default createStore({ Model, 
    state:{

    }, 
    actions({Model}) {
        return {
            selectArts(ctx, { showLoading, showError, body }) {
                return new Model()
                .addPath(`selectArts`)
                .POST({ showLoading, showError, body });
              },
        };
    }
});
